import _ from '@lodash';
import { AppBar, Button, Dialog, DialogActions, DialogContent, IconButton, Toolbar, Typography, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/LookupActions';

const styles = theme => ({
    toolbarDialog: {
        background: 'linear-gradient(to right, ' + theme.palette.primary.dark + ' 0%, ' + theme.palette.primary.main + ' 100%)',
    }
});

class LookupDialog extends XAPPComponent {

    closeComposeDialog = () => {
        const { id, multiSelect, closeDialog, campoid, onChange, selected } = this.props;
        closeDialog(id);
    };

    canBeSubmitted = () => {
        const { selected = null } = this.props;
        return (!_.isNull(selected) && selected.length > 0)
    }

    render() {
        const { lookupDialog, listagem, id, classes } = this.props;
        return (
            <Dialog
                onClose={this.closeComposeDialog}
                open={lookupDialog.length > 0 && lookupDialog.includes(id) ? true : false}
                fullWidth
                fullScreen
                key={id + "_Dialog"}
            >
                <AppBar className={classes.toolbarDialog} position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={this.closeComposeDialog}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent className="p-0">
                    <React.Fragment>
                        {listagem}
                    </React.Fragment>
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0">
                        <Typography variant="subtitle1" color="inherit">
                            <DialogActions>
                                <Button
                                    className="bg-green hover:bg-green text-white mr-8"
                                    onClick={this.closeComposeDialog}
                                    variant="contained"
                                    key={id + "_ButtonOK"}
                                    disabled={!this.canBeSubmitted()}
                                >
                                    OK
                                </Button>
                            </DialogActions>
                        </Typography>
                    </Toolbar>
                </AppBar>
            </Dialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeDialog: Actions.closeDialog,
    }, dispatch);
}

function mapStateToProps({ LookupApp }) {
    return {
        lookupDialog: LookupApp.lookupDialog
    }
}


export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(LookupDialog));


